// assets
import {
    IconTypography,
    IconPalette,
    IconShadow,
    IconBuildingStore,
    IconWindmill,
    IconDevices,
    IconAffiliate,
    IconCoin,
    IconUserPlus
} from '@tabler/icons';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ArticleIcon from '@mui/icons-material/Article';
import RedeemIcon from '@mui/icons-material/Redeem';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EventIcon from '@mui/icons-material/Event';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SellIcon from '@mui/icons-material/Sell';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import BuildIcon from '@mui/icons-material/Build';
// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconDevices,
    IconAffiliate,
    Inventory2OutlinedIcon,
    IconCoin,
    IconUserPlus,
    SummarizeIcon,
    AssignmentReturnedIcon,
    IconBuildingStore,
    ReceiptIcon,
    FolderOpenIcon,
    ArticleIcon,
    RedeemIcon,
    FileDownloadIcon,
    ReceiptLongIcon,
    EventIcon,
    AssistantDirectionIcon,
    AddLocationAltIcon,
    CompareArrowsIcon,
    ManageSearchIcon,
    SellIcon,
    ViewQuiltIcon,
    BuildIcon
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //
function children() {
    const children = [];
    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('18')) {
            children.push(
                {
                    id: 'shops',
                    title: 'Shops',
                    caption: 'A-one Shop',
                    type: 'collapse',
                    icon: icons.IconBuildingStore,

                    children: [
                        {
                            id: 'shobps',
                            title: 'Stock',
                            // caption: 'Shops for sale',
                            type: 'item',
                            url: '/stockcontroller/shops',
                            target: false,
                            icon: icons.IconBuildingStore
                        },
                        {
                            id: 'invoice',
                            title: 'Invoice',
                            type: 'item',
                            url: '/stockcontroller/invoice',
                            target: false,
                            icon: icons.ReceiptIcon
                        }
                        // {
                        //     id: 'mobile',
                        //     title: 'Mobile',
                        //     type: 'item',
                        //     url: '/menu/shops/mobile',
                        //     target: false,
                        //     icon: icons.IconDeviceMobile
                        // },
                        // {
                        //     id: 'tablet',
                        //     title: 'Tablet',
                        //     type: 'item',
                        //     url: '/menu/shops/tablet',
                        //     target: false,
                        //     icon: icons.IconDeviceTablet
                        // }
                    ]
                },
                {
                    id: 'inventory',
                    title: 'Inventory',
                    type: 'collapse',
                    // url: '/stockcontroller/inventory',
                    icon: icons.Inventory2OutlinedIcon,
                    breadcrumbs: false,
                    children: [
                        {
                            id: 'import',
                            title: 'Import',
                            type: 'item',
                            url: '/stockcontroller/inventory/import',
                            target: false,
                            icon: icons.FileDownloadIcon
                        },
                        {
                            id: 'stock',
                            title: 'Receipt Import',
                            type: 'item',
                            url: '/stockcontroller/inventory/receipt',
                            target: false,
                            icon: icons.ReceiptLongIcon
                        },
                        {
                            id: 'stock',
                            title: 'Import List',
                            type: 'item',
                            url: '/stockcontroller/inventory/importlist',
                            target: false,
                            icon: icons.ArticleIcon
                        }
                    ]
                },
                {
                    id: 'repairstock',
                    title: 'Repair Stock',
                    caption: 'ເຄື່ອງສົ່ງສ້ອມແປງ',
                    type: 'item',
                    url: '/stockcontroller/repairstock',
                    target: false,
                    icon: icons.BuildIcon
                }
            );
        }
        if (Roles.includes('39')) {
            children.push({
                id: 'preodermanage',
                title: 'Preorder Management',
                type: 'item',
                url: '/stockcontroller/preorder',
                target: false,
                icon: icons.AssignmentReturnedIcon
            });
            children.push({
                id: 'movement',
                title: 'History',
                type: 'item',
                url: '/stockcontroller/movement',
                icon: icons.SummarizeIcon,
                breadcrumbs: false
            });
        }

        if (Roles.includes('5')) {
            children.push({
                id: 'product',
                title: 'Product Controller',
                type: 'item',
                url: '/stockcontroller/product',
                icon: icons.IconDevices,
                breadcrumbs: false
            });
        }
        if (Roles.includes('50')) {
            children.push({
                id: 'premiums',
                title: 'Premiums',
                type: 'collapse',
                // url: '/stockcontroller/inventory',
                icon: icons.RedeemIcon,
                breadcrumbs: false,
                children: [
                    {
                        id: 'premiumstock',
                        title: 'Premiums Stock',
                        type: 'item',
                        url: '/stockcontroller/premiums/stock',
                        icon: icons.Inventory2OutlinedIcon,
                        target: false
                    },
                    {
                        id: 'importPremium',
                        title: 'Import stock',
                        type: 'item',
                        url: '/stockcontroller/premiums/import',
                        target: false,
                        icon: icons.FileDownloadIcon
                    },
                    {
                        id: 'premiumscontroller',
                        title: 'Premiums Controller',
                        type: 'item',
                        url: '/stockcontroller/premiums',
                        icon: icons.RedeemIcon,
                        target: false
                    }
                ]
            });
        }
        if (Roles.includes('57')) {
            children.push({
                id: 'consignment',
                title: 'Consignment controller',
                type: 'collapse',
                // url: '/stockcontroller/inventory',
                icon: icons.AssistantDirectionIcon,
                breadcrumbs: false,
                children: [
                    {
                        id: 'consign_manament',
                        title: 'Requirement',
                        type: 'item',
                        url: '/stockcontroller/consignment/requirement',
                        icon: icons.AssignmentReturnedIcon,
                        target: false
                    },
                    {
                        id: 'consign_temporary',
                        title: 'Temporary Invoice',
                        type: 'item',
                        url: '/stockcontroller/consignment/temporaryinvoice',
                        icon: icons.SellIcon,
                        target: false
                    },
                    {
                        id: 'add_location',
                        title: 'Add Location',
                        type: 'item',
                        url: '/stockcontroller/consignment/addlocation',
                        icon: icons.AddLocationAltIcon,
                        target: false
                    }

                    // {
                    //     id: 'consign_location',
                    //     title: 'Consign',
                    //     type: 'item',
                    //     url: '/stockcontroller/consignment/consign',
                    //     icon: icons.CompareArrowsIcon,
                    //     target: false
                    // },
                    // {
                    //     id: 'consignment_history',
                    //     title: 'Consignment History',
                    //     type: 'item',
                    //     url: '/stockcontroller/consignment/history',
                    //     icon: icons.ManageSearchIcon,
                    //     target: false
                    // }
                ]
            });
        }

        if (Roles.includes('22')) {
            children.push({
                id: 'customer',
                title: 'Customer Controller',
                type: 'item',
                url: '/menu/customer',
                target: false,
                icon: icons.IconUserPlus
            });
        }

        if (Roles.includes('18')) {
            children.push({
                id: 'reportaone',
                title: 'A-one Report',
                caption: 'A-one Report',
                type: 'collapse',
                icon: icons.FolderOpenIcon,
                children: [
                    {
                        id: 'Sale',
                        title: 'A-one Sale Report',
                        type: 'item',
                        url: '/stockcontroller/report/saletocustomer',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'import',
                        title: 'A-one Inventory Import Report',
                        type: 'item',
                        url: '/stockcontroller/report/inventoryimport',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'SalePremuims',
                        title: 'A-one Premiums Sale Report',
                        type: 'item',
                        url: '/stockcontroller/report/salepremiumstocustomer',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'premiumhistory',
                        title: 'Premiums History',
                        type: 'item',
                        url: '/stockcontroller/premiums/history',
                        icon: icons.RedeemIcon,
                        target: false
                    },
                    {
                        id: 'SaleSummary',
                        title: 'A-one Sale Summary Report',
                        type: 'item',
                        url: '/stockcontroller/report/aonesalesummary',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'agingReport',
                        title: 'Aging Stock Report',
                        type: 'item',
                        url: '/stockcontroller/report/agingstock',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'agingdashboardReport',
                        title: 'Aging Dashboard',
                        type: 'item',
                        url: '/stockcontroller/report/agingstockdashboard',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'SaleEDIFile',
                        title: 'EDI Samsung file sale',
                        type: 'item',
                        url: '/stockcontroller/report/edisalefile',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'reports-inventory-dashboard',
                        title: 'Inventory dashboard report (A-ONE)',
                        type: 'item',
                        url: '/stockcustomer/reports/inventorydashboard',
                        icon: icons.ViewQuiltIcon,
                        breadcrumbs: false
                    }
                ]
            });
            children.push({
                id: 'reportvip',
                title: 'VIP Report',
                caption: 'Customer Report',
                type: 'collapse',
                icon: icons.FolderOpenIcon,
                children: [
                    {
                        id: 'dashboardvip',
                        title: 'Dashboard Stock VIP',
                        type: 'item',
                        url: '/stockcustomer/report/dashboardvip',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'SaleEDIFile',
                        title: 'EDI Samsung file sale VIP',
                        type: 'item',
                        url: '/stockcontroller/report/edisalefilevip',
                        target: false,
                        icon: icons.ArticleIcon
                    }
                ]
            });
            children.push({
                id: 'reportFOTA',
                title: 'FOTA & SellOut ',
                caption: 'FOTA & SellOut From Samsung Official',
                type: 'collapse',
                icon: icons.EventIcon,
                children: [
                    {
                        id: 'dashboardfota',
                        title: 'FOTA & SellOut Report',
                        type: 'item',
                        url: '/stockcontroller/report/fota',
                        target: false,
                        icon: icons.ArticleIcon
                    },
                    {
                        id: 'importfota',
                        title: 'Import FOTA & SellOut',
                        type: 'item',
                        url: '/stockcontroller/report/fota/import',
                        target: false,
                        icon: icons.ArticleIcon
                    }
                ]
            });
        }
        // children.push({
        //     id: 'agent',
        //     title: 'Agent',
        //     type: 'item',
        //     url: '/stockcontroller/agent',
        //     icon: icons.IconAffiliate,
        //     breadcrumbs: false
        // });

        // if (Roles.includes('30')) {
        //     children.push();
        // }

        // if (Roles.includes('34')) {
        //     children.push();
        // }
    }
    return children;
}
const stockcontroller = {
    id: 'stockcontroller',
    title: 'Stock Controller',
    type: 'group',
    children: children()
    //     [
    //     {
    //         id: 'inventory',
    //         title: 'Inventory',
    //         type: 'collapse',
    //         // url: '/stockcontroller/inventory',
    //         icon: icons.Inventory2OutlinedIcon,
    //         breadcrumbs: false,
    //         children: [
    //             {
    //                 id: 'import',
    //                 title: 'Import',
    //                 type: 'item',
    //                 url: '/stockcontroller/inventory/import',
    //                 target: false
    //             },
    //             {
    //                 id: 'stock',
    //                 title: 'Receipt Import',
    //                 type: 'item',
    //                 url: '/stockcontroller/inventory/receipt',
    //                 target: false
    //             }
    //         ]
    //     },
    //     {
    //         id: 'product',
    //         title: 'Product Controller',
    //         type: 'item',
    //         url: '/stockcontroller/product',
    //         icon: icons.IconDevices,
    //         breadcrumbs: false
    //     },
    //     {
    //         id: 'customer',
    //         title: 'Customer Controller',
    //         type: 'item',
    //         url: '/menu/customer',
    //         target: false,
    //         icon: icons.IconUserPlus
    //     },
    //     {
    //         id: 'agent',
    //         title: 'Agent',
    //         type: 'item',
    //         url: '/stockcontroller/agent',
    //         icon: icons.IconAffiliate,
    //         breadcrumbs: false
    //     }
    //     // {
    //     //     id: 'exchangerate',
    //     //     title: 'Exchange Rate',
    //     //     type: 'item',
    //     //     url: '/stockcontroller/exchangerate',
    //     //     target: false,
    //     //     icon: icons.IconCoin
    //     // }
    //     // {
    //     //     id: 'util-shadow',
    //     //     title: 'Shadow',
    //     //     type: 'item',
    //     //     url: '/utils/util-shadow',
    //     //     icon: icons.IconShadow,
    //     //     breadcrumbs: false
    //     // },
    //     // {
    //     //     id: 'icons',
    //     //     title: 'Icons',
    //     //     type: 'collapse',
    //     //     icon: icons.IconWindmill,
    //     //     children: [
    //     //         {
    //     //             id: 'tabler-icons',
    //     //             title: 'Tabler Icons',
    //     //             type: 'item',
    //     //             url: '/icons/tabler-icons',
    //     //             breadcrumbs: false
    //     //         },
    //     //         {
    //     //             id: 'material-icons',
    //     //             title: 'Material Icons',
    //     //             type: 'item',
    //     //             url: '/icons/material-icons',
    //     //             breadcrumbs: false
    //     //         }
    //     //     ]
    //     // }
    // ]
};

export default stockcontroller;
